// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__Pl76c","image":"loader_image__Dd6FJ","title":"loader_title__EU4G9","sub_title":"loader_sub_title__ENKiD","button":"loader_button__SCZRv"};